  
<loader-pane-fragment [trace]="traceNames.viewBudgetCosts"></loader-pane-fragment>
<top-menu [showPrint]="true"></top-menu>

<div class="wrap100">
  <tip-text *ngIf="!hideTip" [type]="'tip'" [head]="'Tip'" [body]="costTip" [showClose]="true" (close)="hideCostTip()"></tip-text>
  <div class="header-strip" *ngIf="!!budget">
    <event-status [dotOnly]="false" [readOnly]="readOnly || closed"></event-status>
    <div style="flex:1;"></div>
    <div class="actions">
      <div style="flex:1;"></div>
      <action-button *ngIf="!closed" [text]="readOnly ? 'EDIT MODE' : 'VIEW MODE'" (click)="readOnly = !readOnly"></action-button>
      <h5 *ngIf="!closed" class="snapshot" [matMenuTriggerFor]="snapshot">
        <span>{{ !budget?.costSnapshots?.length ? '+ Save a snapshot' : 'Snapshots'}}</span>
        <span class="down-arrow" *ngIf="budget?.costSnapshots?.length"></span>
      </h5>
      <action-button id="exportButton" [text]="'EXPORT'" (click)="export()"></action-button>

    </div>
  </div>
  <budget-totals-strip *ngIf="!!budget" class="costs"
    [discount]="budget.costsDiscount"
    [fees]="budget.costsFees"
    [readOnly]="readOnly || closed"
    [subtotal]="budget.costsSubtotal"
    [tax]="budget.costsTax"
    [total]="budget.totalCosts"
    [currency]="budget.currency"
    (changeCurrency)="changeCurrency($event)"
  ></budget-totals-strip>
</div>

<div class="wrap100 scrolling-body">
  <ng-container *ngFor="let costId of budget?.costIds; first as first; last as last; index as index;">
    <ng-container *ngIf="costId !== 'tasks' && costId !== 'assets' && budget.sections[costId] as section">
      <tip-text 
        *ngIf="section.linkJustDeleted" [type]="'important'" 
        [body]="'The quote this was linked from has been deleted.'"
        [showClose]="true"
        (close)="markDeletedLinkSection(section.id)"
      ></tip-text>
      <budget-section *ngIf="!!sectionGridDatas[section.id] && !!scheduleGridDatas[section.id]"
        [first]="first"
        [last]="last"
        [viewMode]="readOnly || closed"
        [canAddItems]="true"
        [allowSectionOrdering]="!readOnly && !closed"
        (addItem)="addItem($event, costId)"
        (moveUp)="moveUp(index)"
        (moveDown)="moveDown(index)"
        [section]="section" 
        [budgetCurrency]="budget.currency"
        [readOnly]="!!section.linkId || readOnly || closed"
        [hasChanges]="!!linkedChangedSectionsMap[section.id]"
        [isRevenue]="false"
        [gridData]="sectionGridDatas[section.id]"
        [scheduleGridData]="scheduleGridDatas[section.id]"
        (saveSection)="saveSection($event)"
        (changeSectionSettingDefaults)="saveSectionSettingDefaults($event)"
        (deleteSection)="deleteSection(costId)"
        [linkDropdownOptions]="section.isQuote ? manageQuoteLinkDropdownOptions : null"
        (linkDropdownSelection)="quoteLinkDropdownSelection(section.id, $event)"
        (viewUpdates)="viewUpdates(section, linkedChangedSectionsMap[section.id], true)"
      ></budget-section>
    </ng-container>
    <ng-container *ngIf="costId === 'tasks' && budget.sections[costId] as section">
      <budget-section *ngIf="!!sectionGridDatas[section.id] && { showUpdates: hasChangedTasks && taskUpdatesOpen } as vars"
        [first]="first"
        [last]="last"
        [viewMode]="readOnly || closed"
        [allowSectionOrdering]="!readOnly && !closed"
        [canAddItems]="false"
        [section]="budget?.sections.tasks" 
        [budgetCurrency]="budget.currency"
        [hasChanges]="hasChangedTasks"
        [updatesLabel]="hasChangedTasks && !taskUpdatesOpen ? 'UPDATES AVAILABLE' : 'HIDE UPDATES'"
        [hideQuantityUpdateColumn]="!vars.showUpdates"
        [hideActionUpdateColumn]="!vars.showUpdates"
        [isRevenue]="false"
        [readOnly]="true"
        [canAddLines]="false"
        [gridData]="sectionGridDatas[section.id]"
        (saveSection)="saveSection($event)"
        (changeSectionSettingDefaults)="saveSectionSettingDefaults($event)"
        (deleteSection)="deleteSection(costId)"
        [linkDropdownOptions]="manageBudgetTasksDropdownOptions"
        (linkDropdownSelection)="budgetTasksDropdownSelection($event)"
        (moveUp)="moveUp(index)"
        (moveDown)="moveDown(index)"
        (viewUpdates)="toggleTaskUpdates()"
      ></budget-section>
    </ng-container>
    <ng-container *ngIf="costId === 'assets' && budget.sections[costId] as section">
      <hr/>
      <budget-section *ngIf="!!sectionGridDatas[section.id] && { showUpdates: hasChangedAssets && assetUpdatesOpen } as vars"
        [first]="first"
        [last]="last"
        [viewMode]="readOnly || closed"
        [allowSectionOrdering]="!readOnly && !closed"
        [canAddItems]="false"
        [section]="budget?.sections.assets" 
        [budgetCurrency]="budget.currency"
        [hasChanges]="hasChangedAssets"
        [updatesLabel]="hasChangedAssets && !assetUpdatesOpen ? 'UPDATES AVAILABLE' : 'HIDE UPDATES'"
        [hideQuantityUpdateColumn]="!vars.showUpdates"
        [hideActionUpdateColumn]="!vars.showUpdates"
        [isRevenue]="false"
        [readOnly]="false"
        [canAddLines]="false"
        [gridData]="sectionGridDatas[section.id]"
        [scheduleGridData]="scheduleGridDatas[section.id]"
        (saveSection)="saveSection($event)"
        (quantityUpdated)="updateAssetQuantity($event)"
        (changeSectionSettingDefaults)="saveSectionSettingDefaults($event)"
        (deleteSection)="deleteSection(costId)"
        [linkDropdownOptions]="manageBudgetAssetsDropdownOptions"
        (linkDropdownSelection)="budgetAssetsDropdownSelection($event)"
        (moveUp)="moveUp(index)"
        (moveDown)="moveDown(index)"
        (viewUpdates)="toggleAssetUpdates()"
      ></budget-section>
    </ng-container>
  </ng-container>
  <div class="buttons-line" *ngIf="!readOnly && !closed">
    <button class="secondary" (click)="addSection()">+ ADD SECTION</button>
    <button *ngIf="!budget?.sections.tasks && !!costTasksToggleSection?.lineItems.length" class="secondary" (click)="manageTasks()">+ LINK TASKS</button>
    <button *ngIf="!budget?.sections.assets && !!costAssetsToggleSection?.lineItems.length" class="secondary" (click)="manageAssets()">+ LINK ASSETS</button>
    <button *ngIf="!!linkableQuoteSections?.length" class="secondary" (click)="linkQuoteSection($event)">+ LINK QUOTE</button>
  </div>
</div>

<mat-menu #snapshot="matMenu" xPosition="before" class="snapshot_menus">
  <h5>SNAPSHOTS</h5>
  <div class="caption" *ngIf="!budget?.costSnapshots?.length">No snapshots</div>
  <div mat-menu-item class="item" *ngFor="let shot of budget?.costSnapshots" (click)="openSnapshot(shot)">
    <div class="name">{{ shot.name }}</div>
    <div class="time">{{ shot.timestamp | date:'h:mma, EEE d MMM'}}</div>
  </div>
  <mat-progress-spinner *ngIf="savingSnapshot" [diameter]="25" mode="indeterminate" color="primary"></mat-progress-spinner>
  <button class="snap_item" (click)="saveSnapshot()">+ SAVE A SNAPSHOT</button>
</mat-menu>

